<template>
  <div class="page-container">
    <PageHeader title="用户管理" show-breadcrumb />

    <!-- 搜索面板：姓名/账号/岗位/部门 -->
    <SearchPanel>
      <el-input v-model.trim="query.zauName" placeholder="用户姓名" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-input v-model.trim="query.zauPhone" placeholder="账号/手机号" clearable size="small" @keyup.enter.native="handleSearch" />
      <el-select v-model="query.zauPost" placeholder="岗位" clearable size="small">
        <el-option v-for="item in postOptions" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-select v-model="query.zadId" placeholder="部门" clearable size="small" filterable>
        <el-option v-for="item in departmentList" :key="item.zadId" :label="item.zadName" :value="item.zadId" />
      </el-select>
      <template #actions>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">查询</el-button>
        <el-button icon="el-icon-refresh" size="small" @click="handleReset">重置</el-button>
        <el-button type="success" icon="el-icon-plus" size="small" @click="handleAdd">新增用户</el-button>
      </template>
    </SearchPanel>

    <TablePanel title="用户列表">
      <el-table :data="list" v-loading="loading" size="small" stripe :height="tableHeight">
        <el-table-column type="index" label="序号" width="80" align="center" />
        <el-table-column prop="zauName" label="用户姓名" min-width="140" align="center" show-overflow-tooltip />
        <el-table-column prop="zauPhone" label="账号/手机号" min-width="150" align="center" show-overflow-tooltip />
        <el-table-column label="岗位" min-width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag size="small" :type="postTagType(row.zauPost)">{{ postText(row.zauPost) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="部门" min-width="140" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">{{ row.zadName || row.zadId || '-' }}</template>
        </el-table-column>
        <el-table-column prop="avOwnerName" label="所属项目" min-width="160" align="center" show-overflow-tooltip />
        <el-table-column label="操作" width="240" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" style="color:#409eff" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" size="mini" style="color:#67c23a" @click="handleResetPw(row)">重置密码</el-button>
            <el-button type="text" size="mini" style="color:#e6a23c" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </TablePanel>

    <!-- 新增/编辑用户弹框 -->
    <el-dialog :title="dialogType === 'add' ? '新增用户' : '编辑用户'" :visible.sync="dialogVisible" width="540px" v-dialog-drag-resize>
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="用户姓名" prop="zauName">
          <el-input v-model.trim="form.zauName" placeholder="请输入用户姓名" />
        </el-form-item>
        <el-form-item label="账号/手机号" prop="zauPhone">
          <el-input v-model.trim="form.zauPhone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="密码" prop="zauPw">
          <el-input v-model.trim="form.zauPw" type="password" show-password :placeholder="dialogType === 'add' ? '请输入密码' : '为空则不修改密码'" />
        </el-form-item>
        <el-form-item label="岗位" prop="zauPost">
          <el-select v-model="form.zauPost" placeholder="请选择岗位" style="width:100%">
            <el-option
              v-for="item in postOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="!isAdmin && item.value !== 3"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isAdmin" label="关联项目" prop="projectId">
          <el-select v-model="form.projectId" placeholder="请选择项目" filterable style="width:100%">
            <el-option v-for="item in projectList" :key="item.zapId" :label="item.zapName" :value="item.zapId" />
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="zadId">
          <el-select v-model="form.zadId" placeholder="请选择部门（选填）" clearable filterable style="width:100%">
            <el-option v-for="item in departmentList" :key="item.zadId" :label="item.zadName" :value="item.zadId" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="submitDialog">确定</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码弹框 -->
    <el-dialog title="重置密码" :visible.sync="resetVisible" width="440px" v-dialog-drag-resize>
      <el-form ref="resetFormRef" :model="resetForm" :rules="resetRules" label-width="90px" size="small">
        <el-form-item label="新密码" prop="zauPw">
          <el-input v-model.trim="resetForm.zauPw" type="password" show-password placeholder="请输入新密码" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="resetVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="resetLoading" @click="submitReset">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue'
import SearchPanel from '@/components/SearchPanel.vue'
import TablePanel from '@/components/TablePanel.vue'
import { getZqpkAuthUserList, addZqpkAuthUser, updateZqpkAuthUser, deleteZqpkAuthUser, resetZqpkAuthUserPw, getZqpkAuthDepartmentList, getZqpkAuthProjectList } from '@/api/api'

// 岗位字典：1 系统管理员 / 2 项目管理员 / 3 用户
const POST_MAP = { 1: { label: '系统管理员', type: 'danger' }, 2: { label: '项目管理员', type: 'warning' }, 3: { label: '用户', type: 'info' } }

export default {
  name: 'AuthUser',
  components: { PageHeader, SearchPanel, TablePanel },
  data () {
    return {
      loading: false,
      tableHeight: 400,
      list: [],
      query: { zauName: '', zauPhone: '', zauPost: '', zadId: '' },
      page: { currentPage: 1, pageSize: 10, total: 0 },
      postOptions: [
        { value: 1, label: '系统管理员' },
        { value: 2, label: '项目管理员' },
        { value: 3, label: '用户' }
      ],
      departmentList: [],
      projectList: [],
      dialogVisible: false,
      dialogType: 'add',
      submitLoading: false,
      form: { zauId: null, zauName: '', zauPhone: '', zauPw: '', zauPost: '', zadId: '', projectId: '' },
      resetVisible: false,
      resetLoading: false,
      resetForm: { zauId: null, zauPw: '' },
      resetRules: {
        zauPw: [{ required: true, message: '请输入新密码', trigger: 'blur' }]
      }
    }
  },
  computed: {
    isAdmin () {
      const u = this.$store.state.user.userInfo || {}
      return u.zauPost === 1
    },
    // 当前登录用户的项目 id（项目管理员新增/编辑用户时锁定为此项目）
    currentUserProjectId () {
      const u = this.$store.state.user.userInfo || {}
      return u.avOwnerId || ''
    },
    // 新增时密码必填，编辑时选填
    rules () {
      const r = {
        zauName: [{ required: true, message: '请输入用户姓名', trigger: 'blur' }],
        zauPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        zauPost: [{ required: true, message: '请选择岗位', trigger: 'change' }]
      }
      if (this.dialogType === 'add') {
        r.zauPw = [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
      return r
    }
  },
  created () {
    this.fetchList()
    this.fetchDepartments()
    // 关联项目字段仅系统管理员可见，仅系统管理员需要加载项目列表
    if (this.isAdmin) this.fetchProjectList()
  },
  mounted () {
    this.$nextTick(this.calcTableHeight)
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy () { window.removeEventListener('resize', this.calcTableHeight) },
  methods: {
    postText (post) { return (POST_MAP[post] && POST_MAP[post].label) || '-' },
    postTagType (post) { return (POST_MAP[post] && POST_MAP[post].type) || 'info' },
    calcTableHeight () {
      const el = this.$el.querySelector('.el-table')
      if (!el) return
      this.tableHeight = window.innerHeight - el.getBoundingClientRect().top - 80
    },
    async fetchList () {
      this.loading = true
      try {
        const params = { ...this.query, currentPage: this.page.currentPage, pageSize: this.page.pageSize }
        const res = await getZqpkAuthUserList(params)
        this.list = res.data || []
        this.page.total = res.total || 0
      } catch (e) { this.list = []; this.page.total = 0 } finally { this.loading = false }
    },
    // 获取部门下拉数据（筛选与表单共用）
    async fetchDepartments () {
      try {
        const res = await getZqpkAuthDepartmentList({ currentPage: 1, pageSize: 999 })
        this.departmentList = res.data || []
      } catch (e) { this.departmentList = [] }
    },
    // 获取项目下拉数据（系统管理员选项目；项目管理员后端仅返回所属项目）
    async fetchProjectList () {
      try {
        const res = await getZqpkAuthProjectList({ currentPage: 1, pageSize: 999 })
        this.projectList = res.data || []
      } catch (e) { this.projectList = [] }
    },
    handleSearch () { this.page.currentPage = 1; this.fetchList() },
    handleReset () { this.query = { zauName: '', zauPhone: '', zauPost: '', zadId: '' }; this.handleSearch() },
    handleSizeChange (size) { this.page.pageSize = size; this.handleSearch() },
    handlePageChange (page) { this.page.currentPage = page; this.fetchList() },
    handleAdd () {
      this.dialogType = 'add'
      // 系统管理员可选项目；项目管理员锁定为自己项目
      const projectId = this.isAdmin ? '' : this.currentUserProjectId
      this.form = { zauId: null, zauName: '', zauPhone: '', zauPw: '', zauPost: this.isAdmin ? '' : 3, zadId: '', projectId }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit (row) {
      this.dialogType = 'edit'
      this.form = { zauId: row.zauId, zauName: row.zauName || '', zauPhone: row.zauPhone || '', zauPw: '', zauPost: row.zauPost, zadId: row.zadId || '', projectId: this.isAdmin ? (row.avOwnerId || '') : this.currentUserProjectId }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    submitDialog () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitLoading = true
        try {
          if (this.dialogType === 'add') {
            await addZqpkAuthUser(this.form)
            this.$message.success('新增成功')
          } else {
            await updateZqpkAuthUser(this.form)
            this.$message.success('编辑成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {} finally {
          this.submitLoading = false
        }
      })
    },
    handleResetPw (row) {
      this.resetForm = { zauId: row.zauId, zauPw: '' }
      this.resetVisible = true
      this.$nextTick(() => this.$refs.resetFormRef && this.$refs.resetFormRef.clearValidate())
    },
    submitReset () {
      this.$refs.resetFormRef.validate(async valid => {
        if (!valid) return
        this.resetLoading = true
        try {
          await resetZqpkAuthUserPw(this.resetForm)
          this.$message.success('密码重置成功')
          this.resetVisible = false
        } catch (e) {} finally {
          this.resetLoading = false
        }
      })
    },
    async handleDelete (row) {
      try { await this.$confirm('确定删除该用户？', '提示', { type: 'warning' }) } catch { return }
      try {
        await deleteZqpkAuthUser({ zauId: row.zauId })
        this.$message.success('删除成功')
        this.fetchList()
      } catch (e) {}
    }
  }
}
</script>
